"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DateTimeModifier_1 = require("./DateTimeModifier");
const DateTimeConfig_1 = __importDefault(require("./DateTimeConfig"));
const cache_1 = require("@almservices-cl/cache");
class DateTimeModifierMock extends DateTimeModifier_1.DateTimeModifierImpl {
    constructor(config = new DateTimeConfig_1.default(new cache_1.InMemoryCache(), {
        dateTime: "YYYY-MM-DD HH:mm:ss",
        date: "YYYY-MM-DD",
        time: "HH:mm:ss",
    })) {
        super();
        const that = this;
        config.onChange({
            setFormats(dateTimeFormat, dateFormat) {
                that.setFormats(dateTimeFormat, dateFormat);
            },
        });
    }
}
exports.default = DateTimeModifierMock;
//# sourceMappingURL=DateTimeModifierMock.js.map